<header class="topbar">

  <div>

    <span class="topbar-label">
      Gerenciamento
    </span>

    <h1>
      Tarifas por data
    </h1>

    <p>
      Configure valores especiais para datas específicas.
      Essas tarifas substituem o valor padrão da diária.
    </p>

  </div>

</header>


<section class="tarifas-section">


  <!-- FILTROS -->

  <div class="filtros-container">

    <div class="campo">

      <label for="quarto">
        Acomodação
      </label>

      <select
        id="quarto"
        [(ngModel)]="quartoSelecionado"
        (ngModelChange)="trocarQuarto()"
      >

        <option
          *ngFor="let quarto of quartos"
          [ngValue]="quarto"
        >

          {{ quarto.nome }}

        </option>

      </select>

    </div>


    <button
      type="button"
      class="btn-nova"
      (click)="abrirModalCadastro()"
      [disabled]="!quartoSelecionado"
    >

      <span>
        +
      </span>

      Nova tarifa por data

    </button>

  </div>


  <!-- LOADING -->

  <div
    class="loading"
    *ngIf="carregando"
  >

    Carregando tarifas...

  </div>


  <!-- LISTA -->

  <div
    class="datas-lista"
    *ngIf="
      !carregando &&
      tarifas.length > 0
    "
  >


    <div
      class="data-card"
      *ngFor="
        let data of agruparPorData()
      "
    >


      <div class="data-card-header">

        <div>

          <span class="section-label">
            Tarifa especial
          </span>

          <h2>
            {{ formatarData(data) }}
          </h2>

          <p>
            {{ quartoSelecionado?.nome }}
          </p>

        </div>


        <div class="data-acoes">

          <button
            type="button"
            class="btn-editar"
            (click)="abrirModalEdicao(data)"
          >

            Editar

          </button>


          <button
            type="button"
            class="btn-excluir"
            (click)="excluir(data)"
            [disabled]="salvando"
          >

            Excluir

          </button>

        </div>

      </div>


      <div class="tarifas-grid">


        <div
          class="tarifa-card"
          *ngFor="
            let quantidade of [].constructor(
              quartoSelecionado?.capacidade || 0
            );

            let i = index
          "
        >

          <span>

            {{ i + 1 }}
            hóspede{{ i > 0 ? 's' : '' }}

          </span>


          <strong
            *ngIf="
              obterTarifa(
                data,
                i + 1
              ) !== null
            "
          >

            R$
            {{
              obterTarifa(
                data,
                i + 1
              ) | number:'1.2-2'
            }}

          </strong>


          <strong
            class="sem-valor"
            *ngIf="
              obterTarifa(
                data,
                i + 1
              ) === null
            "
          >

            Não informado

          </strong>

        </div>


      </div>


    </div>


  </div>


  <!-- VAZIO -->

  <div
    class="empty"
    *ngIf="
      !carregando &&
      tarifas.length === 0
    "
  >

    <div class="empty-icon">
      $
    </div>

    <h3>
      Nenhuma tarifa especial cadastrada
    </h3>

    <p>
      Cadastre valores específicos para datas
      em que deseja alterar a tarifa padrão.
    </p>



  </div>


</section>


<!-- MODAL -->

<div
  class="modal-overlay"
  *ngIf="modalAberto"
  (click)="fecharModal()"
>


  <div
    class="modal"
    (click)="$event.stopPropagation()"
  >


    <div class="modal-header">

      <div>

        <span class="section-label">
          {{ quartoSelecionado?.nome }}
        </span>

        <h2>

          {{
            modoEdicao
              ? 'Editar tarifa por data'
              : 'Nova tarifa por data'
          }}

        </h2>

      </div>


      <button
        type="button"
        class="modal-fechar"
        (click)="fecharModal()"
      >

        ×

      </button>

    </div>


    <form
      class="modal-form"
      (ngSubmit)="salvar()"
    >


      <!-- DATA -->

      <div class="campo">

        <label for="data">
          Data
        </label>

        <input
          id="data"
          type="date"
          name="data"
          [(ngModel)]="dataSelecionada"
          [disabled]="salvando || modoEdicao"
          required
        >

        <small>
          A tarifa será aplicada somente para esta data.
        </small>

      </div>


      <!-- TARIFAS -->

      <div class="tarifas-container">


        <div class="tarifas-header">

          <div>

            <span class="section-label">
              Valores das diárias
            </span>

            <h3>
              Tarifas especiais
            </h3>

            <p>
              Informe o valor da diária para cada
              quantidade de hóspedes adultos.
            </p>

          </div>

        </div>


        <div class="tarifas-grid-form">


          <div
            class="campo"
            *ngFor="
              let quantidade of [].constructor(
                quartoSelecionado?.capacidade || 0
              );

              let i = index
            "
          >

            <label>

              {{ i + 1 }}
              hóspede{{ i > 0 ? 's' : '' }}

            </label>


            <div class="tarifa-input">

              <span>
                R$
              </span>

              <input
                type="number"
                min="0"
                step="0.01"
                [name]="'tarifa_' + (i + 1)"
                [(ngModel)]="
                  tarifasFormulario[i + 1]
                "
                [disabled]="salvando"
                required
              >

            </div>

          </div>


        </div>


      </div>


      <!-- AVISO -->

      <div class="aviso">

        <strong>
          Como funciona
        </strong>

        <p>
          Os valores cadastrados aqui terão prioridade
          sobre a tarifa padrão do dia da semana para
          esta data específica.
        </p>

      </div>


      <!-- AÇÕES -->

      <div class="modal-acoes">

        <button
          type="button"
          class="btn-cancelar"
          (click)="fecharModal()"
          [disabled]="salvando"
        >

          Cancelar

        </button>


        <button
          type="submit"
          class="btn-salvar"
          [disabled]="salvando"
        >

          {{
            salvando
              ? 'Salvando...'
              : (
                modoEdicao
                  ? 'Salvar alterações'
                  : 'Cadastrar tarifa'
              )
          }}

        </button>

      </div>


    </form>


  </div>

</div>
